import { expVal } from '@atlassian/jira-feature-experiments';
import type { IntlShape } from '@atlassian/jira-intl';
import type { Project } from '../../../../common/types.tsx';
import { messages } from '../../messages.tsx';

export const getCoreProjectDefaultBoard = (project: Project, intl: IntlShape) => {
	const boardsHeadingGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.boardsHeadingGalaxia
		: messages.boardsHeading;

	return {
		heading: intl.formatMessage(boardsHeadingGalaxia),

		items: [
			{
				content: intl.formatMessage(messages.coreBoardTitle),
				href: `/projects/${project.key}/board`,
				type: 'core',
			},
		],
	};
};
